<template>
    <b-row class="align-items-center mb-3">
        <b-col sm="12" md="4">
            <div class="form-group">
                <datetime
                    v-model="search.fecha"
                    input-class="form-control"
                    type="date"
                    input-id="fecha"
                    placeholder="Seleccionar fecha"
                    @change="updateLiquidaciones(1)"
                />
            </div>                    
        </b-col>
        <b-col sm="12" md="4" class="pt-0 pt-md-4 mb-3">
            <b-form-select 
                v-model="search.status" 
                :options="status_options"
                @change="updateLiquidaciones(1)"
            />
        </b-col>
        <b-col sm="12" md="4" class="pt-0 pt-md-2">
            <b-button
                size="sm"
                @click="borrarFiltros()"
                class="mb-2 mb-md-0 w-100 btn-crear-liquidacion"
            >
                Borrar filtros
            </b-button>
        </b-col>
    </b-row>
</template>

<script>
    export default {
        data() {
            return {
                search: {
                    status: null,
                    fecha: null
                },
                status_options: [
                    { value: null, text: 'Seleccionar estado' },
                    { value: 0, text: 'Pendiente' },
                    { value: 1, text: 'En revisión' },
                    { value: 2, text: 'Liquidado' },
                ]
            }
        },
        methods: {
            updateLiquidaciones(page) {
                this.$emit('updateLiquidaciones', page, this.search);
            },
            borrarFiltros() {
                this.search = {
                    status: null,
                    fecha: null
                }

                this.updateLiquidaciones(1);
            }
        }
    }
</script>